
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"view.notification.bar.details":"Details","view.notification.bar.count":"({{countNumber}} Fälle)"},"en":{"view.notification.bar.details":"Details","view.notification.bar.count":"({{countNumber}} cases)"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();